import actions from "src/modules/pe-basic-module/data/actions"
import { GET_FEED_ACTION } from "src/modules/pe-basic-module/data/actionTypes"
import { useEffect, useState } from "react"


export default function useAds() : boolean { 
    const [isLoad, setIsLoad] = useState<boolean>(false)
    const getAds = () => {
        actions(GET_FEED_ACTION, {
            data_type: "Ad", 
            land_id: 'all',
            count: 6,
            includeFields: "land { id title }"
        })
        .then(() => setIsLoad(true))
    } 
    useEffect(() => getAds(), []) 
    return isLoad
}